import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartType, registerables } from 'chart.js';

Chart.register(...registerables);

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('chartCanvas', { static: false }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() type: ChartType = 'bar';
  @Input() data: any;
  @Input() options?: ChartConfiguration['options'];
  
  private chart: Chart | null = null;

  ngOnInit(): void {
    // Component initialization
  }

  ngAfterViewInit(): void {
    this.createChart();
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.chart) {
      // Chart not created yet; it will be created in ngAfterViewInit with latest inputs
      return;
    }

    let requiresRecreate = false;
    if (changes['type']) {
      requiresRecreate = true;
    }

    if (requiresRecreate) {
      this.refreshChart();
      return;
    }

    if (changes['data']) {
      this.chart.data = this.data;
    }
    if (changes['options']) {
      this.chart.options = this.options || {};
    }
    this.chart.update();
  }

  private createChart(): void {
    if (!this.chartCanvas) {
      return;
    }

    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (!ctx) {
      return;
    }

    const config: ChartConfiguration = {
      type: this.type,
      data: this.data,
      options: this.options || {}
    };

    this.chart = new Chart(ctx, config);
  }

  // Method to update chart data dynamically
  updateChart(data: any): void {
    if (this.chart) {
      this.chart.data = data;
      this.chart.update();
    }
  }

  // Method to destroy and recreate chart
  public refreshChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.createChart();
  }
}

